<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Pricing and Availablity</span>
  
      </div>
    </div>
    <d-card class="card-small mb-4">
 
      <d-card-header class="border-bottom">
        <h6 class="m-0">Upload Vtex Product</h6>

 
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
           

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">From Country *</label>
                    <div class="col-md-4">
                      <select class="form-control" v-model="GenericUpload.DataModel.Data.FromCountry">
                    <option style="padding:50px" v-for="Dropdown in GenericUpload.Masters.CountryMaster" :value="Dropdown" :key="Dropdown.ReferenceNo" >{{ Dropdown.FromCountry }}</option>
                    </select>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Generic Input file *</label>
                    <div class="col-md-7" v-if="GenericUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" :disabled="(GenericUpload.DataModel.Data.FromCountry ==null || GenericUpload.DataModel.Data.GenericInputCount ==0 || GenericUpload.DataModel.UIData.UploadedDataCount > 0 )" class="btn-accent" @click="getQuery" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ GenericUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="(GenericUpload.DataModel.UIData.UploadedDataCount > 0 && GenericUpload.DataModel.Data.GenericInputCount > 0)">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.Data.GenericInputCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.UIData.UploadedDataCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="GenericUpload.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in GenericUpload.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.Data.PanelInfo.Country}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.Progressed > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Updated </label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{GenericUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.Template"  :name="GenericUpload.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Data </span>   </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.GenericInputTemplateCount" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.GenericInputTemplate"  :name="GenericUpload.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Generic Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.AvailablityList"  :name="GenericUpload.DataModel.UIData.AvailabilityTemplateFileName"><span style="marige-top:10px;" > Download Availability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.minMaxList"  :name="GenericUpload.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Price min & max Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
          <d-col md="12" class="form-group row"  v-if="GenericUpload.DataModel.UIData.RejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="GenericUpload.DataModel.UIData.RejectedList"  name="RejectedList"><span style="marige-top:10px;" > Download Rejected List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                                   
                  

                  <!--  
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Amazon File</label>
                    <div class="col-md-7">
                     <ejs-uploader ref="uploadObj" id='Amazonfileupload' name="UploadFiles"></ejs-uploader>
                    </div>
                  </d-col> -->

                </d-form-row>
                 <!-- <d-button type="button" id="submit" class="btn-accent" @click="getQuery">run</d-button> -->
                <br />
                <div class style="text-align:center"  v-if="GenericUpload.DataModel.UIData.UploadedDataCount >0 && GenericUpload.DataModel.UIData.IsSTWRequest==false">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(GenericUpload.DataModel.Data.PanelInfo.Country == null || GenericUpload.DataModel.Data.FromCountry ==null || GenericUpload.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>
                <div class style="text-align:center"  v-if="GenericUpload.DataModel.UIData.IsSTWRequest==true">
                  <d-button type="button" id="submit" title="Please Select the panel" v-if="GenericUpload.DataModel.UIData.Progressed == 0"  :disabled="(GenericUpload.DataModel.UIData.GenericInputTemplateCount==0)" class="btn-accent" @click="UpdateSTWPricing" style="margin-right:10px" >Update STW</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>


              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="GenericUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'GenericUpload',
   data() {
    return {
      GenericUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            GenericInputCount:[],
            Token:null,
            Curd:null,
            CreatedBy:0,
            
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            IsSTWRequest:false,
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            GenericInputTemplate:[],
            RejectedList:[],
            AvailablityList:[],
            GenericInputTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            },            {
              Name : "STW All Country",
              Country:"All_Country",
              Panel:"STW"
            }

          ]
        },
      },
    };
  },

  mounted(){
      this.GenericUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.GenericUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.GenericUpload.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
     this.GenericUpload.DataModel.UIData.IsSTWRequest = false;
},

panelOnchange(){


            this.GenericUpload.DataModel.UIData.Template=[];
            this.GenericUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.GenericUpload.DataModel.UIData.Template = [];
            this.GenericUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.GenericUpload.DataModel.Data.GenericInputCount = 0;
            this.GenericUpload.DataModel.UIData.UploadedDataCount = 0;
            this.GenericUpload.DataModel.UIData.GenericInputTemplateCount=false;
            this.GenericUpload.DataModel.UIData.Progressed = 0;
            this.GenericUpload.DataModel.UIData.RejectedList=[];
            this.GenericUpload.DataModel.UIData.IsSTWRequest = false;
        this.GenericUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.GenericUpload.DataModel.Data.FromCountry =null;
        this.GenericUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
      let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      this.GenericUpload.DataModel.Data.CRUD = "ListAllFromCountry";
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.GenericUpload.Masters.CountryMaster = response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


getQuery()
{
      let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      this.GenericUpload.DataModel.Data.CRUD = "GenericInput";
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);
      

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.GenericUpload.DataModel.UIData.UploadedDataCount= vm.GenericUpload.DataModel.Data.GenericInputCount;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
},



      GetList(){
      let vm = this;
      vm.GenericUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      
      this.GenericUpload.DataModel.UIData.FileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.GenericUpload.DataModel.UIData.AvailabilityFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.GenericUpload.DataModel.UIData.AvailabilityTemplateFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.GenericUpload.DataModel.UIData.MinMaxFileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.GenericUpload.DataModel.Data.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.GenericUpload.DataModel.Data);

      ListParameter.GenericInputCount = [];
      var dataString = null;
        

        // ListParameter.CRUD = "GetVtexList";
        // dataString = JSON.stringify(ListParameter);
        // this.GetVtexList(dataString);
       if(this.GenericUpload.DataModel.Data.PanelInfo.Panel == "STW")
       {
        ListParameter.CRUD = "GetSTWInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);

       }
       else
       {
          ListParameter.CRUD = "GetGenericInputList";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);

       }

        



      },


      GenericUploadData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.GenericUpload.DataModel.Data.Token = Token;
      this.GenericUpload.DataModel.Data.CRUD = "Create";
      this.GenericUpload.DataModel.UIData.FileName = this.GenericUpload.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.GenericUpload.DataModel.Data);
       vm.GenericUpload.PageLoad = true;
       vm.GenericUpload.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.GenericUpload.DataModel.UIData.UploadedDataCount = response.data.Result;
            

          } else {
              console.log(response.data.ErrorInfo);
              vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },



UpdateSTWPricing(){

// vm.GenericUpload.DataModel.UIData.GenericInputTemplate
  this.UpdatePrice(this);
},

UpdatePrice : async (mythis) => {  
   let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.GenericUpload.DataModel.Data.Token = Token;
      mythis.GenericUpload.DataModel.Data.CRUD = "ProductPricing";
      mythis.GenericUpload.DataModel.UIData.UploadStatus = false;
      mythis.GenericUpload.DataModel.UIData.RejectedList=[];
      mythis.GenericUpload.DataModel.UIData.Progressed = 0;
      for (var i = 0; i < mythis.GenericUpload.DataModel.UIData.GenericInputTemplate.length; i++) {
          // mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i]
          var PriceInfo={
            ASIN:mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].ASIN,
            // SKUId:0,
            markup: 5,
            basePrice: Number(mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: Number(mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            fixedPrices: [
           {
            tradePolicyId: "1",
            value: Number(mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: 1,
            minQuantity: 1
          },
          {
            tradePolicyId: "2",
            value: Number(mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].KSA_Price),
            listPrice: 1,
            minQuantity: 1
         },
         {
            tradePolicyId: "3",
            value: Number(mythis.GenericUpload.DataModel.UIData.GenericInputTemplate[i].India_Price),
            listPrice: 1,
            minQuantity: 1
        } 
        ]
        }

          vm.GenericUpload.DataModel.Data.ProductPricing = Utilities.JsonCopy(PriceInfo);




          var dataString = JSON.stringify(vm.GenericUpload.DataModel.Data);
          vm.GenericUpload.PageLoad = true;
          vm.GenericUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.GenericUpload.PageLoad = false;
               if(response.data.Result.code == undefined)
               {
                  var objFailed ={
                    Asin:vm.GenericUpload.DataModel.Data.ProductPricing.ASIN,
                    Error:response.data.Result
                  }
                  mythis.GenericUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(objFailed));
               }
               else
               {
                 mythis.GenericUpload.DataModel.UIData.Progressed+=1;
               }
          } else {
              console.log(response.data.ErrorInfo);
              mythis.GenericUpload.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.GenericUpload.PageLoad = false;
        }
       }
},
      

  // UploadedDataCount
  

      GetGenericInputList(dataString){
       let vm = this;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Successfully Generated.");
            vm.GenericUpload.DataModel.UIData.GenericInputTemplate= response.data.Result              
            if(vm.GenericUpload.DataModel.UIData.GenericInputTemplate.length > 0)
            vm.GenericUpload.DataModel.UIData.GenericInputTemplateCount = true;
            vm.GenericUpload.DataModel.UIData.IsSTWRequest=true;

            // vm.GenericUpload.DataModel.UIData.GenericInputTemplate 

          } else {
              console.log(response.data.ErrorInfo);
                vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.GenericUpload.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.GenericUpload.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_Buybox_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_Buybox_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.GenericUpload.DataModel.UIData.Template = response.data.Result;
            
            if(vm.GenericUpload.DataModel.UIData.Template.length > 0)
            vm.GenericUpload.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.GenericUpload.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.GenericUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.GenericUpload.PageLoad = true;
      this.GenericUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.GenericUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.GenericUpload.DataModel.Data.GenericInputCount = 0 ;
        //   this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `GenericInput` (`ASIN`, `Category`, `Weight`, `Country`, `buybox_new_landed_price`, `FromPanel`, `Buybox_seller`, `CreatedBy`) VALUES";
          this.GenericUpload.DataModel.Data.QueryString = "INSERT INTO `VtexProductInfo` (`SkuId`, `SkuName`, `ProductId`, `ProductName`, `DepartamentId`, `DepartamentName`, `CategoryId`, `CategoryName`,`BrandId`, `Brand` ) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
                SkuId : 0,
                SkuName : null,	
                ProductId : 0,
                ProductName : null,
                DepartamentId : 0,
                DepartamentName : null,
                CategoryId : 0,
                CategoryName : null,
                BrandId : 0,
                Brand : null
            }


            if(ws[i].SkuId !=undefined)
            {
                ScrabData.SkuId = ws[i].SkuId;
            }
            else
            {
              ScrabData.SkuId = null;
            }

            if(ws[i].SkuName !=undefined )
            {
                 ScrabData.SkuName = ws[i].SkuName;
            }
            else
            {
                ScrabData.SkuName = 0;
            }
            if(ws[i].ProductId !=undefined)
            {
                ScrabData.ProductId = ws[i].ProductId;
            }
            else
            {
              ScrabData.ProductId = null;
            }

            if(ws[i].ProductName !=undefined )
            {
                 ScrabData.ProductName = ws[i].ProductName;
            }
            else
            {
                ScrabData.ProductName = 0;
            }

            if(ws[i].DepartamentId !=undefined)
            {
                ScrabData.DepartamentId = ws[i].DepartamentId;
            }
            else
            {
              ScrabData.DepartamentId = null;
            }

            if(ws[i].DepartamentName !=undefined)
            {
                ScrabData.DepartamentName = ws[i].DepartamentName;
            }
            else
            {
              ScrabData.DepartamentName = null;
            }
            
            if(ws[i].CategoryId !=undefined)
            {
                ScrabData.CategoryId = ws[i].CategoryId;
            }
            else
            {
              ScrabData.CategoryId = null;
            }

            if(ws[i].CategoryName !=undefined)
            {
                ScrabData.CategoryName = ws[i].CategoryName;
            }
            else
            {
              ScrabData.CategoryName = null;
            }

            if(ws[i].BrandId !=undefined)
            {
                ScrabData.BrandId = ws[i].BrandId;
            }
            else
            {
              ScrabData.BrandId = null;
            }

            if(ws[i].Brand !=undefined)
            {
                ScrabData.Brand = ws[i].Brand;
            }
            else
            {
              ScrabData.Brand = null;
            }


        //    if(ws[i].Brand !=undefined)
        //     {
        //         ScrabData.Brand = ws[i].Brand;
        //     }
        //     else
        //     {
        //       ScrabData.Brand = null;
        //     }


             ScrabData.CreatedBy = this.GenericUpload.SessionInfo.PageInfo.userId;

            this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString + "(\'" + ScrabData.SkuId + "\',\'" +ScrabData.SkuName + "\',\'" +ScrabData.ProductId + "\',\'" + ScrabData.ProductName + "\',\'" +ScrabData.DepartamentId + "\',\'" +ScrabData.DepartamentName + "\',\'" +ScrabData.CategoryId + "\',\'" +ScrabData.CategoryName + "\',\'" +ScrabData.BrandId + "\',\'" +ScrabData.Brand + "\' )";

            if(i < (ws.length - 1))
            {
              this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+"," 
            }
            this.GenericUpload.DataModel.Data.GenericInputCount +=1;
            
            // this.GenericUpload.DataModel.Data.GenericInputCount.push(ScrabData);
            //  excellist.push(ws[i]);
          }

          
           this.GenericUpload.DataModel.Data.QueryString = this.GenericUpload.DataModel.Data.QueryString+";"
          // console.log("Read results", this.GenericUpload.DataModel.Data.GenericInputCount); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.GenericUpload.DataModel.Data.GenericInputCount);  
          this.GenericUpload.PageLoad = false;
        //    console.log(this.GenericUpload.DataModel.Data.QueryString); 
          // this.GenericUpload.DataModel.Data.QueryString = JSON.stringify(this.GenericUpload.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.GenericUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },	

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>